import { type PropsWithChildren, Suspense } from 'react'

import { FallBack } from '@components'
import { useCookieBanner, useInitAnalytics, usePreloader, useSetTokens } from '@hooks'

export function AppInitGate({ children }: PropsWithChildren) {
  useInitAnalytics()
  useCookieBanner()
  useSetTokens()
  usePreloader()

  return <Suspense fallback={<FallBack />}>{children}</Suspense>
}
